import { InputRule } from '@milkdown/kit/prose/inputrules';
import { $inputRule } from '@milkdown/kit/utils';
import { replace } from 'out-of-character';

import { videoNode, isVideoFile, extractFilenameFromUrl } from './video';

/**
 * Video URL regex pattern for input rule.
 * Matches URLs ending with common video file extensions.
 *
 * Supports:
 * - .mp4, .mov, .avi, .wmv, .flv, .webm, .mkv, .m4v
 * - URLs with query parameters (e.g., ?t=10)
 * - Trailing invisible characters (common when pasting from rich text)
 *
 * @internal Exported for testing only
 */
export const VIDEO_URL_INPUT_REGEX =
  /(?:https?:\/\/)?[^\s]+\.(?:mp4|mov|avi|wmv|flv|webm|mkv|m4v)(?:\?[^\s]*)?[\u200B-\u200D\uFEFF\u00AD]*$/i;

/**
 * Input rule: pasting/typing a video URL creates a video block.
 * Triggered when user types/pastes a URL ending with a video extension.
 */
export const videoInputRule = $inputRule(
  (ctx) =>
    new InputRule(VIDEO_URL_INPUT_REGEX, (state, match, start, end) => {
      const [rawUrl] = match;
      if (!rawUrl) {
        return null;
      }

      // Clean invisible chars before storing in node
      const url = replace(rawUrl);

      // Double-check it's a video file
      if (!isVideoFile(url)) {
        return null;
      }

      const { tr } = state;

      // Replace the URL text with a video node
      tr.replaceWith(
        start,
        end,
        videoNode.type(ctx).create({
          src: url,
          title: extractFilenameFromUrl(url),
          width: 640,
          height: 360,
        }),
      );

      return tr;
    }),
);
